import { NgModule } from '@angular/core';
import { provideNavConfig } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { AdvSearchNavConfigProvider } from './adv-search-nav-config.provider';
import { CanAccessAdvSearchGuard } from './adv-search-navigation-guards';
import { ADV_SEARCH_PATH } from './constants';

export const loadModule = () => import('@capital-access/adv-search/client').then(m => m.AdvSearchClientModule);

@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: ADV_SEARCH_PATH,
          canActivate: [CanAccessAdvSearchGuard],
          loadChildren: loadModule
        }
      ]
    })
  ],
  providers: [provideNavConfig(AdvSearchNavConfigProvider), CanAccessAdvSearchGuard]
})
export class AdvSearchLazyModule {}
